import { useT } from "@transifex/react";
import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";

interface OnlineTestPageNavigationProps {
    currentPage: number;
    totalPages: number;
    onPrevious: () => void;
    onNext: () => void;
}

const OnlineTestPageNavigation = (props: OnlineTestPageNavigationProps) => {
    const t = useT();

    const t_sr_previousPage = t("Previous page", { _tags: "OnlineTest, Navigation, ScreenReaderOnly" });
    const t_sr_nextPage = t("Next page", { _tags: "OnlineTest, Navigation, ScreenReaderOnly" });

    const isPreviousDisabled = props.currentPage <= 1;

    const navButtonClassName =
        "flex items-center justify-center bg-transparent border-none disabled:opacity-30 cursor-pointer disabled:cursor-default";

    const renderNavButton = (direction: "previous" | "next") => {
        const isPrevious = direction === "previous";
        return (
            <button
                onClick={isPrevious ? props.onPrevious : props.onNext}
                disabled={isPrevious ? isPreviousDisabled : false}
                aria-label={isPrevious ? t_sr_previousPage : t_sr_nextPage}
                className={navButtonClassName}
                data-testid={`online-test-${direction}-page`}
            >
                <PhaseSixIcon
                    name={isPrevious ? "chevron-left" : "chevron-right"}
                    className="text-[30px] text-p6-grey-dark"
                />
            </button>
        );
    };

    const renderPageText = () => {
        return (
            <span className="text-l text-p6-grey-dark">
                {props.currentPage} / {props.totalPages}
            </span>
        );
    };

    return (
        <div
            className="z-50 w-full bg-background-light py-s"
            data-testid="online-test-navigation"
        >
            <nav className="max-w-[1000px] mx-auto h-l px-m flex flex-row items-center justify-center gap-s w-full">
                {renderNavButton("previous")}
                {renderPageText()}
                {renderNavButton("next")}
            </nav>
        </div>
    );
};

export default OnlineTestPageNavigation;
